import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export default function Radio(props) {
  const { label, subLabel, checked = false, ...restProps } = props;
  const inputRef = React.useRef(null);

  const radioClass = classnames("radio", {
    "radio--checked": checked,
    "radio--disabled": restProps.disabled,
  });

  return (
    <label tabIndex="0" onKeyUp={handleKeyUp} className={radioClass}>
      <div>
        {label}
        {subLabel && <SubLabel content={subLabel} />}
      </div>

      <input
        ref={inputRef}
        checked={checked}
        type="radio"
        readOnly={true}
        onChange={handleOnChange}
        {...restProps}
      />
    </label>
  );

  function handleKeyUp(e) {
    if (e.keyCode === 32) {
      inputRef.current.click();
    }
  }

  function handleOnChange(event) {
    if (restProps.onChange) {
      restProps.onChange(event);
    }
  }
}

Radio.propTypes = {
  label: PropTypes.string.isRequired,
  subLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

function SubLabel({ content }) {
  if (Array.isArray(content)) {
    return content.map((contentItem, index) => {
      return (
        <span key={index} className="sub_label">
          {contentItem}
        </span>
      );
    });
  } else if (typeof content === "string") {
    return <span className="sub_label">{content}</span>;
  }

  return null;
}

SubLabel.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};
